"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonErrorCount = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonDisplayErrors = require("./ButtonDisplayErrors");

var _ButtonErrorMessage = require("./ButtonErrorMessage");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonErrorCount = function ButtonErrorCount(_ref) {
  var anyTouched = _ref.anyTouched,
      invalid = _ref.invalid,
      submitFailed = _ref.submitFailed,
      type = _ref.type,
      btnText = _ref.btnText,
      cashbotName = _ref.cashbotName,
      errorCount = _ref.errorCount,
      getErrorMessage = _ref.getErrorMessage,
      skipToErrorLinkMessage = _ref.skipToErrorLinkMessage,
      firstErrorField = _ref.firstErrorField,
      ariaDescribedBy = _ref.ariaDescribedBy,
      iconType = _ref.iconType,
      doFocus = _ref.doFocus,
      disabled = _ref.disabled;
  var showErrorMsg = errorCount && anyTouched && invalid && submitFailed;
  var errorMessage = showErrorMsg ? getErrorMessage(errorCount) : null;
  var buttonProps = {
    type: type,
    btnText: btnText,
    cashbotName: cashbotName,
    ariaDescribedBy: ariaDescribedBy,
    doFocus: doFocus,
    disabled: disabled,
    errorDisplayed: !!showErrorMsg
  };
  return _react.default.createElement(_ButtonDisplayErrors.ButtonDisplayErrors, buttonProps, _react.default.createElement(_ButtonErrorMessage.ButtonErrorMessage, {
    errorMessage: errorMessage,
    skipToErrorLinkMessage: skipToErrorLinkMessage,
    firstErrorField: firstErrorField,
    iconType: iconType
  }));
};

exports.ButtonErrorCount = ButtonErrorCount;
ButtonErrorCount.defaultProps = {
  type: 'submit',
  anyTouched: false,
  invalid: false,
  submitFailed: false,
  errorCount: 0,
  getErrorMessage: function getErrorMessage() {},
  skipToErrorLinkMessage: '',
  firstErrorField: null,
  ariaDescribedBy: null,
  iconType: null,
  doFocus: false,
  disabled: false
};
ButtonErrorCount.propTypes = {
  btnText: _propTypes.default.string.isRequired,
  type: _propTypes.default.oneOf(['button', 'submit']),
  anyTouched: _propTypes.default.bool,
  invalid: _propTypes.default.bool,
  submitFailed: _propTypes.default.bool,
  cashbotName: _propTypes.default.string.isRequired,
  errorCount: _propTypes.default.number,
  getErrorMessage: _propTypes.default.func,
  skipToErrorLinkMessage: _propTypes.default.string,
  firstErrorField: _propTypes.default.string,
  ariaDescribedBy: _propTypes.default.string,
  iconType: _propTypes.default.string,
  doFocus: _propTypes.default.bool,
  disabled: _propTypes.default.bool
};